import api from "@/lib/api";

// Credits consumed by a single standard generation (backend GEN_COST).
export const CREDITS_PER_IMAGE = 5;

export const estImages = (credits) => Math.max(0, Math.floor((credits || 0) / CREDITS_PER_IMAGE));

// Start a Stripe checkout for a subscription plan or a one-time credit pack.
export async function startCheckout(payload) {
  const { data } = await api.post("/payments/checkout/session", { ...payload, origin_url: window.location.origin });
  if (data?.url) window.location.href = data.url;
  return data;
}
